export default __webpack_public_path__ + "static/media/peopleSearchStep.42eb5541.png";